import { Typography } from 'core/Typography';
import Image from 'next/image';
import React from 'react';
import SectionWrapper from 'shared/SectionWrapper';

import ContentBlock from '~/components/features/cases/RenessansBank/content-block';

function Card({ title }: { title?: string }) {
    return (
        // eslint-disable-next-line max-len
        <div className="p-[12px] xl-desktop:p-[24px] bg-[#EEFCFF] border-[#11AFCC] rounded-[12px]  xl-desktop:rounded-[24px] border-[1px]">
            <Typography>{title}</Typography>
        </div>
    );
}

function Decision() {
    return (
        <SectionWrapper>
            <div className="flex flex-col gap-[40px] lg-tablet:gap-[60px]">
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <ContentBlock
                        aside
                        titleClassName={'m-0!'}
                        title={'Решение'}
                        asideClassName="m-0! mobile:m-0!"
                        asideContent={[
                            {
                                id: '1',
                                content:
                                    // eslint-disable-next-line max-len
                                    'Наша ИИ-платформа позволяет увидеть за словами кандидата реальные поведенческие индикаторы, помогая рекрутеру дополнить своё профессиональное суждение объективными данными.',
                            },
                        ]}
                    >
                        <Typography>
                            TalentMind — это ИИ-платформа, которая анализирует аудио и видеозаписи
                            интервью HR-специалиста с кандидатом. Так субъективные оценки интервью
                            превращаются в объективные данные, на основании которых бизнес принимает
                            взвешенные решения и формирует сильные команды.
                        </Typography>
                        <Typography>
                            Система распознает речь и транскрибирует её в текст, проводит
                            семантический и лингвистический анализ, выделяет кейсы, о которых
                            рассказывает кандидат (опыт, достижения, участие в проектах). TalentMind
                            объективно и беспристрастно оцениваем десять базовых софт-скилов:
                        </Typography>
                    </ContentBlock>
                </div>
                <div
                    className={
                        'flex flex-wrap gap-[12px] xl-desktop:gap-y-[24px] xl-desktop:gap-x-[40px]'
                    }
                >
                    <Card title="Управленческие навыки" />
                    <Card title="Лидерство" />
                    <Card title="Коммуникация" />
                    <Card title="Планирование и организация процессов" />
                    <Card title="Стрессоустойчивость" />
                    <Card title="Командная работа" />
                    <Card title="Эмпатия" />
                    <Card title="Решение проблем" />
                    <Card title="Критическое мышление" />
                </div>
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <Typography variant={'h3'}>Как работает TalentMind</Typography>
                    <div className="aspect-[1400/267] relative">
                        <Image
                            fill
                            src={`/images/pic/talent-mind/decision.png`}
                            alt={'Как работает TalentMind'}
                            objectFit={'contain'}
                        />
                    </div>
                </div>
            </div>
        </SectionWrapper>
    );
}

export default Decision;
